export const isAdmin = (role) => {
    return role==='Admin';    
}